const SCRIPT_PATH = '/api/consent/cookieConsent';

export function loadCookieConsent() {
  const scriptUrl = window.location.origin + SCRIPT_PATH;

  if (document.querySelector(`script[src="${scriptUrl}"]`)) {
    return;
  }

  const script = document.createElement('script');
  script.src = scriptUrl;
  script.async = true;
  script.onerror = function () {
    console.error('Failed to load consent script: ' + scriptUrl);
  };

  (document.head || document.documentElement).appendChild(script);
}
